var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w-full flex flex-col gap-6" },
    [
      _c(_setup.Toolbar, [
        _c("div", { staticClass: "flex-grow" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pl-4 py-1 flex items-center" },
          [
            _c(
              "samc-button",
              {
                attrs: {
                  disabled:
                    _setup.showValidations && _setup.hasValidationErrors,
                },
                on: {
                  click: function ($event) {
                    return _setup.updateModel()
                  },
                },
              },
              [_vm._v("Save Fields")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _setup.model !== null
        ? _c(
            "div",
            { staticClass: "grid grid-cols-4 gap-6" },
            _vm._l(_setup.fieldGroups, function (group) {
              return _c(
                "div",
                { key: group.key, staticClass: "flex flex-col gap-3" },
                _vm._l(group.value, function (field) {
                  return _c(
                    "samc-field",
                    {
                      key: field.fieldName,
                      attrs: {
                        "error-message": _setup.showValidations
                          ? _setup.validations[
                              _setup.getModelKey(field.fieldName)
                            ] ?? ""
                          : "",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "mt-1 flex justify-between w-full pr-2 items-center field-label",
                          attrs: { slot: "label" },
                          slot: "label",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(field.displayName) +
                              "\n          \n          "
                          ),
                          _c("icon-edit", {
                            staticClass: "cursor-pointer",
                            attrs: { mini: "" },
                            on: {
                              click: function ($event) {
                                _setup.selectedField = field
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      group.key === "rate" || group.key === "decimal"
                        ? _c("samc-number-input", {
                            attrs: {
                              format:
                                group.key === "rate"
                                  ? "#,###.######"
                                  : "#,###.##",
                              value: field.value,
                            },
                            on: {
                              valuechanged: function ($event) {
                                field.value = $event.detail
                              },
                            },
                          })
                        : group.key === "date"
                        ? _c("samc-date-input", {
                            attrs: {
                              value: _setup.convertDate(field.value),
                              format: _setup.dateFormat,
                            },
                            on: {
                              valuechanged: function ($event) {
                                field.value = $event.detail
                              },
                            },
                          })
                        : group.key === "text"
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: field.value,
                                expression: "field.value",
                              },
                            ],
                            attrs: { type: "text" },
                            domProps: { value: field.value },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(field, "value", $event.target.value)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.selectedField !== null
        ? _c(_setup.TransactionExtensionFieldNameModal, {
            attrs: { model: _setup.selectedField },
            on: {
              close: function ($event) {
                _setup.selectedField = null
              },
              update: function ($event) {
                return _setup.updateTransactionExtensionFieldNames($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }